import { Button } from '@octopus-do/octopus-storybook'
import {
  AngleRight,
  DiamondExclamationLight,
} from '@octopus-do/octopus-storybook/icons'
import { SubscriptionActions } from '@store/reducers/subscription'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { InfoBannerContainer } from '../InfoBannerContainer'
import css from './styles.module.css'

export const PaymentFailedBanner: React.FC = () => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(SubscriptionActions.requestBillingPortal())
  }

  return (
    <InfoBannerContainer>
      <div className={css.banner}>
        <div className={css.banner_icon}>
          <DiamondExclamationLight />
        </div>

        <div className={css.banner_text}>
          <div className={css.banner_title}>Payment failed</div>
          <div className={css.banner_description}>
            We couldn't charge your card. Update it to keep your plan.
          </div>
        </div>

        <div className={css.banner_button}>
          <Button
            size="medium"
            label="Update card"
            right={AngleRight}
            onClick={handleClick}
          />
        </div>
      </div>
    </InfoBannerContainer>
  )
}
